import React from 'react';
import PhoneInput from '../../../input/phoneInput/PhoneInput';
import Input from '../../../input/Input';

interface ContactInputFieldProps {
    contactType: 'phone' | 'email';
    index: number;
    label: string;
    placeholder: string;
}

function ContactInputField({contactType, index, label, placeholder}: ContactInputFieldProps) {
    if(contactType === 'phone') {
        return (
            <PhoneInput
                name={`contacts.${index}`}
                countryFieldName={`countryCode.${index}`}
                text={label}
                description={placeholder}
                icon=""
                events={{}}
                className=""
            />
        );
    } else {
        return (
            <Input
                name={`contacts.${index}`}
                text={label}
                description={placeholder}
                events={undefined}
                className={undefined}
                forwardRef={undefined}
                icon={undefined}
            />
        );
    }
}

export default ContactInputField;
